export interface ThreatReviewUrlReport {
  report_id: string;
  url: string;
  category: string;
  reporter_email: string | null;
  submitted_at: string;
  review_status: ThreatReviewUrlReportStatus;
  source: ThreatReviewUrlReportSource;
  priority: ThreatReviewUrlReportPriority;
  submitted_for_approval_at: string;
}

export enum ThreatReviewUrlReportStatus {
  PENDING = "Pending",
  MALICIOUS = "Malicious",
  SAFE = "Safe",
  NOT_ENOUGH_EVIDENCE = "NotEnoughEvidence",
  SPAM = "Spam",
}

export enum ThreatReviewUrlReportPriority {
  HIGH = "High",
  MEDIUM = "Medium",
  LOW = "Low",
}

export enum ThreatReviewUrlReportDecision {
  PENDING = "-",
  APPROVED = "Approved",
  REJECTED = "Rejected",
  PENDING_APPROVAL = "Awaiting Approval",
}

export enum ThreatReviewUrlReportSource {
  COMMUNITY_REPORTED = "CommunityReported",
  SYSTEM_DETECTED = "SystemDetected",
  ADMIN_REPORTED = "AdminReported",
  ADMIN_IMPORTED = "AdminImported",
  USER_APPEALED = "UserAppealed",
}

export interface ThreatReviewCategory {
  code: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
  report_count: number;
}

export interface ThreatReviewStats {
  sources: {
    source: string;
    count: number;
  }[];
  total_reports: number;
}

export interface ThreatReviewUrlReportParams {
  offset?: number;
  limit?: number;
  category?: string;
  status?: string;
  search?: string;
  source?: string;
  priority?: string;
  approvalStatus?: string;
  isForApproval?: boolean;
  allReport?: string;
}

export interface ThreatReviewUrlReportResponse {
  items: ThreatReviewUrlReport[];
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export interface ThreatReviewUrlReportDetail {
  report_id: string;
  url: string;
  domain: string;
  category: string;
  description: string;
  reporter_email: string | null;
  reporter_type: string;
  evidence_files: ThreatReviewUrlReportEvidenceFile[];
  review_status: ThreatReviewUrlReportStatus;
  submitted_at: string;
  reviewed_at: string | null;
  admin_notes: string;
  action_history: ThreatReviewUrlReportActionHistory[];

  engine_score: null;
  ai_score: null;
  finalized_score: null;
  source: ThreatReviewUrlReportSource;
  key_analysis_factors: string;
  summary: string;
  approval_status: ThreatReviewUrlReportDecision;
  submitted_for_approval_at: string | null;
  same_url_report_count: number;
}

export interface UpdateThreatReviewUrlReportParams {
  reportId: string;
  reviewStatus: ThreatReviewUrlReportStatus;
  category: string;
  adminNotes: string;
  summary: string;
  keyAnalysisFactors: string;
  finalizedScore: number;
  email: string;
  is_submit_for_approval?: boolean;
}

export interface ApproveRejectThreatReviewUrlReportParams {
  email: string;
  finalDecision: string;
  isApprovalAction: boolean;
  reportId: string;
}

export interface ThreatReviewUrlReportEvidenceFile {
  s3_key: string;
  presigned_url: string;
}

export interface ThreatReviewUrlReportActionHistory {
  action: string;
  old_value: ThreatReviewUrlReportStatus;
  new_value: ThreatReviewUrlReportStatus;
  username: string;
  timestamp: string;
  notes: string;
}

export enum ThreatReviewCategoryErrorCode {
  SCAM_CAT_CODE_EXISTS = "SCAM_CAT_CODE_EXISTS",
  SCAM_CAT_NAME_EXISTS = "SCAM_CAT_NAME_EXISTS",
  SCAM_CAT_NOT_FOUND = "SCAM_CAT_NOT_FOUND",
  SCAM_CAT_IN_USE = "SCAM_CAT_IN_USE",
}

export interface ThreatReviewCategoryResponse {
  detail: {
    error_code: ThreatReviewCategoryErrorCode;
    message: string;
  };
}

export interface EvidenceFile {
  s3_key: string;
  size_bytes: number;
  uploaded_at: string;
}

export interface AddThreatReviewUrlReportParams {
  url: string;
  type: string;
  description?: string;
  email?: string;
  evidence?: EvidenceFile[];
  isByAdmin?: boolean;
}

export interface UploadScamEvidenceParams {
  fileData: string;
  filename: string;
}

export interface UploadScamEvidenceResponse {
  s3_key: string;
  file_size: number;
  uploaded_at: string;
}

export type FilterPayload = {
  category_id?: string | null;
  status?: string | null;
  search?: string | null;
  source?: string | null;
  priority?: string | null;
  approvalStatus?: string | null;
  limit?: number;
  offset?: number;
  allReport?: string;
  profileType?: string | null;
};
